// Court-type glyph by (lowercased) name — shared by the header and profile so
// the same court type always shows the same icon. Falls back to a generic venue
// marker so unknown types still render something meaningful.
export const sportGlyph = (name = '') => {
  const k = name.toLowerCase();
  if (/บอล|foot|soccer|ฟุต|futsal|ฟุตซอล/.test(k)) return '⚽';
  if (/แบด|badminton/.test(k)) return '🏸';
  if (/บาส|basket/.test(k)) return '🏀';
  if (/เทนนิส|tennis/.test(k)) return '🎾';
  if (/pickle|พิคเกิล|พิกเคิล/.test(k)) return '🏓';
  if (/วอลเลย์|volley/.test(k)) return '🏐';
  return '🏟️';
};
